import React from 'react'
import styles from './SquareSpinner.scss'

export const SquareSpinner = ({size}) => (
  <div className={styles.SquareSpinner} style={{height: size, width: size}}>
    <div />
    <div />
    <div />
    <div />
  </div>
)
